import { Map } from 'immutable';
// immutable has many good use cases. Read more at: https://immutable-js.github.io/immutable-js/
import { ADD_SUB, UPDATE_SUB, DELETE_SUB, POPULATE_SUBS } from '@constants/actions';

const initialState = Map({
  subList: [],
  totalCount: 0,
});

const Subscriptions = (state = initialState, action: any) => {
  const sub = action.payload ? action.payload.sub : null;
  switch(action.type) {
    case POPULATE_SUBS:
      const { subs, totalCount } = action.payload;
      return state.set('subList', subs)
        .set('totalCount', totalCount);
    case ADD_SUB:
    case UPDATE_SUB:
      return state.set(sub.guid, sub);
    case DELETE_SUB:
      return state.delete(sub.guid);
    default:
      return state;
  }
};

export default Subscriptions;